module.exports = __webpack_public_path__ + "sprstatic/img/logo.20b2deed.37e8f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/logo.20b2deed.png
// module id = 60Oq
// module chunks = 2